type TriggerGroup = 'newLead' | 'sources' | 'buyer' | 'seller' | 'subscriptions' | 'other' | 'internal';

class Type {
	public static EXTERNAL_LEAD_CREATED = new Type('IHF_EXTERNAL_LEAD_CREATED', 'New lead from any external source', 'newLead');
	public static FORM_NEW_LEAD = new Type('IHF_FORM_NEW_LEAD', 'New lead from any capture or registration form', 'newLead');
	public static UNMATCHED_LEAD_SOURCE = new Type('IHF_UNMATCHED_LEAD_SOURCE', 'Source does not trigger any automation', 'sources');
	public static USER_REGISTRATION = new Type('IHF_USER_REGISTRATION', 'Registers on your website', 'internal');
	public static CONTACT_REQUEST = new Type('IHF_CONTACT_REQUEST', 'Submits contact form', 'other');
	public static MORE_INFO_REQUEST = new Type('IHF_MORE_INFO_REQUEST', 'Requests more information', 'buyer');
	public static SCHEDULE_SHOWING = new Type('IHF_SCHEDULE_SHOWING', 'Schedules a tour', 'buyer');
	public static SAVED_SEARCH = new Type('IHF_SAVED_SEARCH', 'Saves a search', 'buyer');
	public static SAVED_LISTING = new Type('IHF_SAVED_LISTING', 'Saves a listing', 'buyer');
	public static VALUATION_REQUEST = new Type('IHF_VALUATION_REQUEST', 'Requests a home valuation', 'seller');
	public static PROPERTY_ORGANIZER_SIGNUP = new Type('IHF_PROPERTY_ORGANIZER_SIGNUP', 'Property Organizer', 'other');
	public static LISTING_REPORT_SIGNUP = new Type('IHF_LISTING_REPORT_SIGNUP', 'Listing Reports', 'subscriptions');
	public static OPEN_HOME_REPORT_SIGNUP = new Type('IHF_OPEN_HOME_REPORT_SIGNUP', 'Open Home Reports', 'subscriptions');
	public static MARKET_REPORT_SIGNUP = new Type('IHF_MARKET_REPORT_SIGNUP', 'Market Reports', 'subscriptions');

	private constructor(
		public readonly id: string,
		public readonly label: string,
		public readonly group: TriggerGroup,
	) {}

	public static readonly groupLabels: Record<TriggerGroup, string> = {
		newLead: 'New lead source',
		sources: 'Sources',
		buyer: 'Buyer activity',
		seller: 'Seller activity',
		subscriptions: 'If lead subscribes to',
		other: 'Other lead actions',
		internal: '',
	};

	public static values(): Type[] {
		return Object.values(Type).filter((v): v is Type => v instanceof Type);
	}

	public static getById(id: string): Type | undefined {
		return this.values().find((t) => t.id === id);
	}

	public static byGroup(): Record<TriggerGroup, Type[]> {
		return this.values().reduce((acc, t) => {
			if (!acc[t.group]) {
				acc[t.group] = [];
			}
			acc[t.group].push(t);
			return acc;
		}, {} as Record<TriggerGroup, Type[]>);
	}
}

export { Type as TriggerType };
